import React from 'react';
import { Button, Box, IconButton, Typography } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useParams, useNavigate } from 'react-router-dom';

const Report1 = () => {
  const { reportId } = useParams();
  const navigate = useNavigate();

  
  const sampleReports = [
    {
      id: 1,
      title: "FRAX Report - Goldberry River-Daughter",
      patientName: "Goldberry River-Daughter",
    },
    {
      id: 2,
      title: "CAROC Report - Aragorn Son of Arathorn",
      patientName: "Aragorn Son of Arathorn",
    },
    {
      id: 3,
      title: "FRAX Report - Bilbette Baggins",
      patientName: "Bilbette Baggins",
    }
  ];
  
  const currentReport = sampleReports.find(r => r.id === parseInt(reportId)) || sampleReports[0];
  const currentIndex = sampleReports.findIndex(r => r.id === parseInt(reportId));
  
  const goToPreviousReport = () => {
    if (currentIndex > 0) {
      navigate(`/report/${sampleReports[currentIndex - 1].id}`);
    }
  };
  
  const goToNextReport = () => {
    if (currentIndex < sampleReports.length - 1) {
      navigate(`/report/${sampleReports[currentIndex + 1].id}`);
    }
  };
  
  return (
    <div style={{
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.4',
      margin: 0,
      padding: '20px',
      backgroundColor: '#ffffff',
      color: '#333',
      display: 'flex',
      justifyContent: 'center',
      '@media print': {
        padding: 0,
      },
    }}>
      <Box style={{
        maxWidth: '8.5in',
        width: '100%',
        backgroundColor: '#ffffff',
      }}>
        <Box style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '20px',
          '@media print': {
            display: 'none',
          },
        }}>
          <Box style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <IconButton
              onClick={goToPreviousReport}
              disabled={currentIndex === 0}
              style={{ color: currentIndex === 0 ? '#ccc' : '#0a3d62' }}
            >
              <NavigateBeforeIcon />
            </IconButton>
            <Typography variant="body2" style={{ color: '#666' }}>
              {currentReport.title}
            </Typography>
            <IconButton
              onClick={goToNextReport}
              disabled={currentIndex === sampleReports.length - 1}
              style={{ color: currentIndex === sampleReports.length - 1 ? '#ccc' : '#0a3d62' }}
            >
              <NavigateNextIcon />
            </IconButton>
          </Box>
          
          <Box style={{ display: 'flex', gap: '10px' }}>
            <Button
              variant="outlined"
              onClick={() => navigate('/reports')}
              style={{ borderColor: '#0a3d62', color: '#0a3d62' }}
            >
              All Reports
            </Button>
          </Box>
        </Box>
        <table border="1" style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginBottom: '20px',
        }}>
          <tbody>
            <tr>
              <td style={{verticalAlign: 'top', padding: '20px'}}>
                <div style={{marginTop: '0.125in', marginBottom: '0.125in'}}>
                  <h1 style={{margin: 0, fontSize: '24px', fontWeight: 'bold', textAlign: 'center'}}>C-Encode</h1>
                  <p style={{margin: '5px 0 0 0', fontSize: '14px', textAlign: 'center'}}>9131 Keele St, Unit A4, Vaughan, ON L4K 0G7</p>
                </div>
                
                <div style={{marginBottom: '30px'}}>
                  <div style={{
                    backgroundColor: '#f5f5f5',
                    border: '1px solid #ddd',
                    padding: '8px',
                    marginBottom: '10px',
                    fontSize: '12px',
                    lineHeight: '1.2',
                  }}>
                    <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center', marginBottom: '8px'}}>
                      <div style={{fontWeight: 'bold'}}>Patient:</div>
                      <div>Goldberry River-Daughter</div>
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px'}}>
                      <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center'}}>
                        <div style={{fontWeight: 'bold'}}>Birth Date:</div>
                        <div>1947-01-01</div>
                        <div style={{fontWeight: 'bold'}}>Height:</div>
                        <div>159 cm</div>
                        <div style={{fontWeight: 'bold'}}>Sex:</div>
                        <div>Female</div>
                      </div>
                      <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center'}}>
                        <div style={{fontWeight: 'bold'}}>Age:</div>
                        <div>76 years</div>
                        <div style={{fontWeight: 'bold'}}>Weight:</div>
                        <div>91.4 kg</div>
                        <div style={{fontWeight: 'bold'}}>Study Date:</div>
                        <div>2023-11-22</div>
                      </div>
                    </div>
                    <div style={{marginTop: '8px', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px'}}>
                      <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center'}}>
                        <div style={{fontWeight: 'bold'}}>Ordered By:</div>
                        <div>Dr. Gandalf The Gray</div>
                        <div style={{fontWeight: 'bold'}}>Reported By:</div>
                        <div>Dr. Théoden of Rohan</div>
                      </div>
                      <div style={{display: 'grid', gridTemplateColumns: '100px 1fr', gap: '5px', alignItems: 'center'}}>
                        <div style={{fontWeight: 'bold'}}>CC:</div>
                        <div>Dr. Frodo Baggins, Dr. Samwise Gamgee</div>
                        <div style={{fontWeight: 'bold'}}>Report Date:</div>
                        <div>2023-11-22</div>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div style={{marginTop: '0.125in', marginBottom: '25px'}}>
                  <div style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '15px',
                    backgroundColor: '#0a3d62',
                    color: 'white',
                    padding: '10px 15px',
                    borderRadius: '4px',
                  }}>
                    Comparison Study
                  </div>
                  <div style={{marginTop: '15px'}}>
                    <p>Current study compared to that of <strong>December 1, 2020</strong>.</p>
                  </div>
                </div>
                
                <div style={{marginTop: '0.125in', marginBottom: '25px'}}>
                  <div style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '15px',
                    backgroundColor: '#0a3d62',
                    color: 'white',
                    padding: '10px 15px',
                    borderRadius: '4px',
                  }}>
                    Results
                  </div>
                  <div style={{marginTop: '15px'}}>
                    <table style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      fontSize: '14px',
                      marginTop: '15px',
                    }}>
                      <thead>
                        <tr>
                          <th style={{padding: '10px', borderBottom: '2px solid #ddd', textAlign: 'left', fontWeight: 'bold'}}>Anatomical Region</th>
                          <th style={{padding: '10px', borderBottom: '2px solid #ddd', textAlign: 'center', fontWeight: 'bold'}}>BMD (g/cm²)</th>
                          <th style={{padding: '10px', borderBottom: '2px solid #ddd', textAlign: 'center', fontWeight: 'bold'}}>T-score</th>
                          <th style={{padding: '10px', borderBottom: '2px solid #ddd', textAlign: 'center', fontWeight: 'bold'}}>Change Status</th>
                          <th style={{padding: '10px', borderBottom: '2px solid #ddd', textAlign: 'center', fontWeight: 'bold'}}>Change from Previous</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'left', fontWeight: 'bold'}}>LUMBAR SPINE (L1-L3) *</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center', fontWeight: 'bold'}}>1.003</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center', fontWeight: 'bold'}}>-1.4</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center', fontWeight: 'bold'}}>SIGNIFICANT INCREASE</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center', fontWeight: 'bold'}}>+0.124 g/cm² (14.1%)</td>
                        </tr>
                        <tr>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'left', fontWeight: 'bold'}}>LEFT FEMORAL NECK</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center', fontWeight: 'bold'}}>0.888</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center', fontWeight: 'bold'}}>-1.1</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center', color: '#666'}}>-</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center'}}>-</td>
                        </tr>
                        <tr style={{backgroundColor: '#ffe6e6'}}>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'left', fontWeight: 'bold'}}>LEFT TOTAL PROXIMAL FEMUR</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center', fontWeight: 'bold'}}>0.901</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center', fontWeight: 'bold'}}>-0.8</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center', fontWeight: 'bold'}}>SIGNIFICANT DECREASE</td>
                          <td style={{padding: '10px', borderBottom: '1px solid #eee', textAlign: 'center', fontWeight: 'bold'}}>-0.070 g/cm² (-7.2%)</td>
                        </tr>
                      </tbody>
                    </table>
                    <p style={{fontSize: '12px', fontStyle: 'italic', marginTop: '10px'}}>
                      * Vertebra(e) has/have been excluded from analysis as the T-score(s) is/are at least one standard deviation greater than the T-score of the vertebra with the next highest value.
                    </p>
                  </div>
                </div>
                
                <div style={{marginTop: '0.125in', marginBottom: '25px'}}>
                  <div style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '15px',
                    backgroundColor: '#0a3d62',
                    color: 'white',
                    padding: '10px 15px',
                    borderRadius: '4px',
                  }}>
                    Fracture Risk
                  </div>
                  <div style={{marginTop: '15px'}}>
                    <p>The estimated 10-year risk for a hip fracture is <strong>10%</strong> and for a major osteoporotic fracture is <strong>22%</strong>.</p>
                    <p>This fracture risk estimate was calculated using FRAX (version 4.5). The patient reported the following risk factors: parent fractured hip, glucocorticoid use.</p>
                  </div>
                </div>
                
                <div style={{marginTop: '0.125in', marginBottom: '25px'}}>
                  <div style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '15px',
                    backgroundColor: '#0a3d62',
                    color: 'white',
                    padding: '10px 15px',
                    borderRadius: '4px',
                  }}>
                    Impression and Recommendations
                  </div>
                  <p>Based on lowest T-score, the diagnosis meets WHO criteria for NORMAL bone mass.</p>
                  <p>Based on the current fracture risk, pharmacological intervention is recommended, as per Osteoporosis Canada guidelines. Bisphosphonates are a viable therapeutic option.</p>
                  <p>Non-pharmacological and lifestyle measures are applicable to all patients. All patients should ensure an adequate intake of dietary calcium (1200 mg/d) and vitamin D (800-2000 IU daily).</p>
                  <p>At this facility, the least significant change in BMD with 95% confidence is:</p>
                  <ul style={{margin: '15px 0', paddingLeft: '20px'}}>
                    <li>Lumbar Spine - 0.033 gm/cm²</li>
                    <li>Total Hip - 0.017 gm/cm²</li>
                  </ul>
                </div>
                
                <div style={{marginTop: '0.125in', marginBottom: '25px'}}>
                  <div style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '15px',
                    backgroundColor: '#0a3d62',
                    color: 'white',
                    padding: '10px 15px',
                    borderRadius: '4px',
                  }}>
                    Follow-up Recommendations
                  </div>
                  <p>Follow-up suggested in 3 years.</p>
                </div>
                
                <div style={{marginTop: '40px', textAlign: 'center', fontSize: '12px', color: '#666'}}>
                  <p>Report generated on: 2023-11-22</p>
                  <p>Page 1 of 2</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        
        {/* Second Page with DXA Images */}
        <div style={{pageBreakBefore: 'always'}}></div>
        <table border="1" style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginBottom: '20px',
        }}>
          <tbody>
            <tr>
              <td style={{verticalAlign: 'top', padding: '20px'}}>
                <div style={{marginTop: '0.125in'}}>
                  <h1 style={{margin: 0, fontSize: '24px', fontWeight: 'bold', textAlign: 'center'}}>C-Encode</h1>
                  <p style={{margin: '5px 0 0 0', fontSize: '14px', textAlign: 'center'}}>9131 Keele St, Unit A4, Vaughan, ON L4K 0G7</p>
                </div>
                
                <div style={{marginTop: '0.5in', marginBottom: '25px'}}>
                  <div style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: '15px',
                    backgroundColor: '#0a3d62',
                    color: 'white',
                    padding: '10px 15px',
                    borderRadius: '4px',
                  }}>
                    Appendix
                  </div>
                  
                  <div style={{marginTop: '20px'}}>
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '15px', color: '#0a3d62'}}>AP Spine</h3>
                    <div style={{textAlign: 'left', marginBottom: '30px'}}>
                      <img 
                        src="/17-RIVER-DAUGHTER^GOLDBERRY^L-20231122-DXA Images-7-1.jpg" 
                        alt="AP Spine" 
                        style={{
                          maxWidth: '100%',
                          maxHeight: '250px',
                          height: 'auto',
                          border: '1px solid #ccc',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                      />
                    </div>
                  </div>
                  
                  <div style={{marginTop: '30px'}}>
                    <h3 style={{fontSize: '16px', fontWeight: 'bold', marginBottom: '15px', color: '#0a3d62'}}>Left Femur</h3>
                    <div style={{textAlign: 'left', marginBottom: '30px'}}>
                      <img 
                        src="/17-RIVER-DAUGHTER^GOLDBERRY^L-20231122-DXA Images-8-2.jpg" 
                        alt="Left Femur" 
                        style={{
                          maxWidth: '100%',
                          maxHeight: '250px',
                          height: 'auto',
                          border: '1px solid #ccc',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                      />
                    </div>
                  </div>
                </div>
                
                <div style={{marginTop: '40px', textAlign: 'center', fontSize: '12px', color: '#666'}}>
                  <p>Report generated on: 2023-11-22</p>
                  <p>Page 2 of 2</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </Box>
    </div>
  );
};

export default Report1; 